import {createFileRoute, Outlet} from "@tanstack/react-router";
import {SystemLayout} from "@/layouts/SystemLayout";

export const Route = createFileRoute("/_system")({
  component: Auth,
});

function Auth() {
  return (
    <SystemLayout>
      <Outlet />
    </SystemLayout>
  );
}
